module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v(_vm._s(_vm.fase) + "   \n        "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(219)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 219\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(525, 'S')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 525A\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(525, 'N')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 525S\n            ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>248 - Monitoramento Administrativo</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(248)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 248\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Solicitações',
        href: '#'
      }, {
        text: 'Contrapartida',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [((_vm.historicoTarefasTela.length > 0 && _vm.historicoTarefasTela[1].observacao != null && _vm.historicoTarefasTela[1].observacao !== '')) ? _c('div', {
    staticClass: "alert alert-dismissible alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.historicoTarefasTela[1].observacao)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Validação de Contrapartida - "), _c('i', [_c('font', {
    attrs: {
      "color": "black",
      "size": "3"
    }
  }, [_vm._v("ID: " + _vm._s(_vm.validacao.id) + " - Projeto: ")]), _c('font', {
    attrs: {
      "color": "black",
      "size": "3"
    }
  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-if": "$ctrl.approvalState != 'DEFAULT'"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmSearch",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group required"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('dl', {
    staticClass: "proposal-definition-list"
  }, [_c('dt', [_vm._v("Objetivo Geral: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.proposta.ds_objetivo_geral))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _vm._m(1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.fase === 'Autorização'
    }
  }, [_c('cronograma-solicitacao-contrapartida', {
    ref: "childComponentA",
    attrs: {
      "propsNota": _vm.nota,
      "propsProjeto": _vm.proposta.projeto,
      "propsEtapa": _vm.etapa
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('upload-documentos-php', {
    attrs: {
      "propDocumentos": _vm.nota.documentos,
      "documentTypes": '',
      "disable": ''
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(3), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
    key: _vm.historicoBack.length,
    attrs: {
      "propsValidacao": _vm.validacao,
      "propsHistorico": _vm.historicoBack
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.dataProcesso < '10/12/2020') ? _c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconderHistorico === false) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderHistorico = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderHistorico = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataProcesso < '10/12/2020') ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(4), _vm._v(" "), _c('historico-antigo', {
    key: _vm.historicoTarefas.length,
    attrs: {
      "propsValidacao": _vm.validacao,
      "propsHistorico": _vm.historicoTarefas
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Análise deste documento para Contrapartida")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "form-group required full",
    class: {
      'has-error': _vm.errors.first('resultadoAprovacao')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "resultadoAprovacao"
    }
  }, [_vm._v("Decisão:")]), _vm._v(" "), (_vm.etapa !== 'Revisão') ? _c('div', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Aprovado",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Aprovado")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Aprovado")
      }
    }
  }), _vm._v(" Aprovar documento\n                              "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Revisão",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Revisão")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Revisão")
      }
    }
  }), _vm._v(" Encaminhar para revisão\n                              "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.fase === 'Autorização') ? _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Retornar Análise",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Retornar Análise")
    },
    on: {
      "click": function($event) {
        _vm.showJustify = 'Retonar Análise'
      },
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Retornar Análise")
      }
    }
  }), _vm._v(" Retornar para análise\n                              "), _c('div', {
    staticClass: "new-control-indicator"
  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('resultadoAprovacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultadoAprovacao')))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão') ? _c('div', {
    staticClass: "form-group required-field full",
    class: {
      'has-error': _vm.errors.first('justificativa')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "motivo de devolucao"
    }
  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivoDevolucao),
      expression: "motivoDevolucao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "motivo de devolucao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.motivoDevolucao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Limpar dados do motivo de devolução")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("--------------------------------------------------------------------------")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ausência de Relatório"
    }
  }, [_vm._v("Ausência de Relatório")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ausência de documento - documento fiscal / holerite / ofício"
    }
  }, [_vm._v("Ausência de documento - documento fiscal / holerite / ofício")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ausência de fotos/imagens comprobatórias"
    }
  }, [_vm._v("Ausência de fotos/imagens comprobatórias")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ausência ou divergência de documentos de obra civil (termo de medição, contrato, ART ou RRT)"
    }
  }, [_vm._v("Ausência ou divergência de documentos de obra civil (termo de medição, contrato, ART ou RRT)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ausência ou divergência do número do acordo BNDES "
    }
  }, [_vm._v("Ausência ou divergência do número do acordo BNDES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cadastro desatualizado "
    }
  }, [_vm._v("Cadastro desatualizado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Comprovante de pagamento ausente, divergente ou ilegível "
    }
  }, [_vm._v("Comprovante de pagamento ausente, divergente ou ilegível")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Documento fiscal ilegível ou divergente"
    }
  }, [_vm._v("Documento fiscal ilegível ou divergente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Existência de ocorrência impeditiva"
    }
  }, [_vm._v("Existência de ocorrência impeditiva")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Itens da nota fiscal divergentes do cronograma físico-financeiro"
    }
  }, [_vm._v("Itens da nota fiscal divergentes do cronograma físico-financeiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pendência de prestação de contas"
    }
  }, [_vm._v("Pendência de prestação de contas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Recolhimento de tributos ausente ou divergente"
    }
  }, [_vm._v("Recolhimento de tributos ausente ou divergente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Outros"
    }
  }, [_vm._v("Outros")])])]), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Aprovado') ? _c('div', {
    staticClass: "form-group full",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observação"
    }
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validacao.glosa),
      expression: "validacao.glosa"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observação",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.validacao.glosa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.validacao, "glosa", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão' || _vm.aprovacao.resultadoAprovacao === 'Retornar Análise') ? _c('div', {
    staticClass: "form-group required-field full",
    class: {
      'has-error': _vm.errors.first('justificativa')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v("Motivo para revisão:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validacao.glosa),
      expression: "validacao.glosa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.validacao.glosa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.validacao, "glosa", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(_vm.aprovacao.resultadoAprovacao || _vm.etapa === 'Revisão') ? _c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSave($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.voltaPraSolicitacao($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa fa-info"
  }), _vm._v("   Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_c('span', [_vm._v("Em Execução")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos de solicitação de contrapartida")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico de solicitação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico Antigo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64604eba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/contrapartida/formValidacaoContrapartida.vue
// module id = 1987
// module chunks = 1